
/* ==========================================================
   schoders.js – bereinigt (Sept. 2026)
   Das Offert-Formular läuft komplett in schoders-landing.liquid.
   Hier bleiben nur FAQ-Aufklappen und sanftes Scrollen für die
   ANDEREN Seiten (z.B. /pages/faq). Auf der Startseite macht das
   die Landing selbst – darum wird es dort übersprungen.
   ========================================================== */
(function () {
  // Startseite mit Offert-Formular? Dann nichts tun (Landing erledigt alles)
  if (document.getElementById('offerte')) return;
 
  // FAQ accordion
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });
 
  // Smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href');
      if (href.length < 2) return;
      var target = document.querySelector(href);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });
})();
 